module.exports={
	"Form": "TestSpecificationRequirementViewManifest",
	"Scope": "TestSpecificationRequirement-View",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-View-Identity",
				"Group": "TestSpecificationRequirement-View-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-View-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-View-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-View-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-View-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-View-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-View-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-View-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-View-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-View-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-View-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-View-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecificationRequirement":
		{
			"Name": "IDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-View-IDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.GUIDTestSpecificationRequirement":
		{
			"Name": "GUIDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-View-GUIDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationRequirement-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationRequirement-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationRequirement-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationRequirement-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationRequirement-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationRequirement-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
